import { apiRequest } from "../../../api/apiRequest";
import { DELETE_COHORT, GET_COHORT_GROUPS, GET_TEACHER_DETAILS, POST_CREATE_COHORT, POST_UPDATE_COHORT } from "../../../utils/api";
import { TEACHER_DETAILS_FAILURE } from "../../authentication/auth.actionTypes";
import { COHORT_LIST_FAILURE, COHORT_LIST_SUCCESS, CREATE_COHORT_FAILURE, CREATE_COHORT_SUCCESS, DELETE_COHORT_FAILURE, DELETE_COHORT_SUCCESS, TEACHER_DETAILS_SUCCESS, UPDATE_COHORT_FAILURE, UPDATE_COHORT_SUCCESS } from "./cohort.actionTypes";

export const teacherDetails = (teacherID) => async (dispatch) => {
  const result = await apiRequest("get", `${GET_TEACHER_DETAILS}/${teacherID}`);

  if (result.success) {
    dispatch({
      type: TEACHER_DETAILS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: TEACHER_DETAILS_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const createCohort = (payLoad) => async (dispatch) => {
  const result = await apiRequest("post", POST_CREATE_COHORT, payLoad);

  if (result.success) {
    dispatch({
      type: CREATE_COHORT_SUCCESS,
      payload: result.data ,
    });
    return { success: true };
  }

  dispatch({
    type: CREATE_COHORT_FAILURE,
    payload: { message: result.message },
  });
  return { success: false, message: result.message };
};

export const getTeacherCohort = () => async (dispatch) => {
  const result = await apiRequest("get", `${GET_COHORT_GROUPS}`);

  if (result.success) {
    dispatch({
      type: COHORT_LIST_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: COHORT_LIST_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const deleteTeacherCohort = (id) => async (dispatch) => {
  const result = await apiRequest("delete", `${DELETE_COHORT}/${id}`);

  if (result.success) {
    dispatch({
      type: DELETE_COHORT_SUCCESS,
      payload: result.data,
    });
    return { success: true };
  } else {
    dispatch({
      type: DELETE_COHORT_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, message: result.message };
  }
};

export const updateCohort = (cohortId, payLoad) => async (dispatch) => {
  const result = await apiRequest(
    "post",
    `${POST_UPDATE_COHORT}/${cohortId}`,
    payLoad,
  );

  if (result.success) {
    dispatch({
      type: UPDATE_COHORT_SUCCESS,
      payload: result.data,
    });
    return { success: true, message: result.message };
  }

  dispatch({
    type: UPDATE_COHORT_FAILURE,
    payload: { message: result.message },
  });
  return { success: false, message: result.message };
};